var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 1.33301H6.66732C5.93198 1.33301 5.33398 1.93101 5.33398 2.66634V5.33301H2.66732C1.93198 5.33301 1.33398 5.93101 1.33398 6.66634V13.333C1.33398 14.0683 1.93198 14.6663 2.66732 14.6663H9.33398C10.0693 14.6663 10.6673 14.0683 10.6673 13.333V10.6663H13.334C14.0693 10.6663 14.6673 10.0683 14.6673 9.33301V2.66634C14.6673 1.93101 14.0693 1.33301 13.334 1.33301ZM2.66732 13.333V6.66634H9.33398L9.33532 13.333H2.66732ZM13.334 9.33301H10.6673V6.66634C10.6673 5.93101 10.0693 5.33301 9.33398 5.33301H6.66732V2.66634H13.334V9.33301Z",
    fill: "#8A9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.7172091bbd67c69a38c5bab715e10d77.svg";
export { ForwardRef as ReactComponent };